import styled from 'styled-components';

import variables from '../variables';

const SocialButton = styled.button`
  display: block;
  width: ${props => props.size}px;
  height: ${props => props.size}px;
  color: ${variables.colors.white};
  background-color: ${props => variables.colors[props.color]};
  font-family: Roboto, sans-serif;
  border: 0;
  outline: none;
  white-space: nowrap;
  cursor: pointer;
  position: relative;
  border-radius: ${props => Math.round(props.size / 6)}px;
  margin-right: ${props => Math.round(props.size / 4)}px;
  & > i {
    display: inline-block;
    width: ${props => props.size}px;
    height: ${props => props.size}px;
    line-height: ${props => props.size}px;
    font-size: ${props => Math.round((props.size / 3) * 2.5)}px;
    margin: 0 auto;
  }
`;

SocialButton.defaultProps = {
  color: 'darkerGrey',
  size: 40,
};

export default SocialButton;
